import React from 'react'
import Box from '@material-ui/core/Box'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteOutline from '@material-ui/icons/DeleteOutline'
import { FieldArray, useFormikContext, ErrorMessage } from 'formik'
import map from 'lodash/map'
import toFinite from 'lodash/toFinite'
import size from 'lodash/size'
import isEmpty from 'lodash/isEmpty'

import { appColors } from '../../../../../globalStyles'
import { InputFieldWithLabel, NumberFieldWithLabel } from '../../../../../components/Form/Fields'
import { Button } from '../../../../../components/Button'
import { R, sumCurrency } from '../../../../../utils/currency'
import { ASIDE_VIEWS } from '../../../reducer'

export const DependentsFields = ({ setAsideView }) => {
  const { values: { dependents } } = useFormikContext()
  const disableAdditions = size(dependents) > 10
  return (
    <>
      {!isEmpty(dependents) && <small style={{ marginLeft: '1rem' }}><a onClick={() => setAsideView(ASIDE_VIEWS.DEPENDENTS)}>Learn more about monthly income for dependents</a></small>}
      <FieldArray name='dependents'>
        {({ push, remove }) =>
          <>
            {map(dependents, (_, idx) =>
              <DependentsFieldSet key={idx} idx={idx} onRemove={() => remove(idx)} />
            )}
            <Box
              display='flex'
            >
              <Box flex='2' />
              <Button
                trackAs="Life cover: Add dependents"
                disabled={disableAdditions}
                style={{ flex: 1, marginBottom: '1.5rem' }} textLink onClick={() => push({ name: '', value: 0, time_horizon: '' })}>
                + Add dependents
              </Button>
            </Box>
          </>
        }
      </FieldArray>
    </>
  )
}

const DependentsFieldSet = ({ idx, onRemove }) => {
  return (
    <Box
    >
      <Box
        display='flex'
        alignItems='center'
      >
        <InputFieldWithLabel
          withoutError
          style={{ flex: 2 }}
          label='Dependent name'
          name={`dependents[${idx}].name`}
        />
        <NumberFieldWithLabel
          withoutError
          style={{ flex: 2 }}
          label='Monthly income'
          name={`dependents[${idx}].value`}
        />
        <NumberFieldWithLabel
          withoutError
          style={{ flex: 2 }}
          label='Number of years'
          name={`dependents[${idx}].time_horizon`}
        />
        <Box
          style={{ cursor: 'pointer' }}
          color={appColors.system}
          onClick={onRemove}
        >
          <Tooltip title='Remove dependent'>
            <DeleteOutline />
          </Tooltip>
        </Box>
      </Box>
      <ErrorMessage className='app-form__field-error' component='span' name={`dependents[${idx}.name]`} />
      <ErrorMessage className='app-form__field-error' component='span' name={`dependents[${idx}.value]`} />
      <ErrorMessage className='app-form__field-error' component='span' name={`dependents[${idx}.time_horizon]`} />
    </Box>
  )
}

export const sumDependents = (formValues) => {
  const { dependents } = formValues
  return sumCurrency(
    map(dependents, (dependent) =>
      (R(dependent.value).value * 12 * toFinite(dependent.time_horizon)) || 0
    )
  ).value
}
